/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinqrdownloadpng3Inputs */

const en_checkinqrdownloadpng3 = /** @type {(inputs: Checkinqrdownloadpng3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download as PNG`)
};

const de_checkinqrdownloadpng3 = /** @type {(inputs: Checkinqrdownloadpng3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als PNG laden`)
};

/**
* | output |
* | --- |
* | "Download as PNG" |
*
* @param {Checkinqrdownloadpng3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinqrdownloadpng3 = /** @type {((inputs?: Checkinqrdownloadpng3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinqrdownloadpng3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinqrdownloadpng3(inputs)
	return de_checkinqrdownloadpng3(inputs)
});
export { checkinqrdownloadpng3 as "checkinQrDownloadPng" }